import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import Loading from 'react/components/Loading/Loading';

import { actionCreators } from 'react/api/actions/quickAssignment';

function EquipmentAssignmentItem({
  routeId, assignment, canBeRemoved, updatePrimaryEquipment
}) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const { equipment, principal } = useMemo(() => assignment, [assignment]);

  function updateEquipmentsList() {
    const routeRouter = new App.Routers.Route();

    const successCallback = (data) => {
      dispatch(actionCreators.updateEquipmentAssignments({
        assignments: data,
        routeId
      }));
    };

    const options = {
      routeId
    };

    routeRouter.getEquipmentsByRoute(options, successCallback);
  }

  function handleUnassignEquipment() {
    setIsLoading(true);

    const payload = {
      assignmentId: assignment.id,
      routeId
    };

    const model = new App.Models.RouteEquipmentAssignment();
    model.unassignToRoute(
      payload,
      () => {
        if (principal) {
          updateEquipmentsList();
          setIsLoading(false);
        } else {
          dispatch(actionCreators.unassignEquipment(payload));
          setIsLoading(false);
        }
      },
      () => setIsLoading(false)
    );
  }

  const rightIcon = useMemo(() => {
    if (canBeRemoved && !isLoading) {
      return (
        <button
          type="button"
          data-testid="remove-icon-button"
          onClick={handleUnassignEquipment}
          className="remove-icon"
        />
      );
    }

    if (isLoading) {
      return <Loading width="20px" height="20px" />;
    }

    return null;
  }, [canBeRemoved, isLoading]);

  return (
    <div
      data-testid={`equipment-assignment-${equipment.key}`}
      className={principal ? 'equipment-assigned primary' : 'equipment-assigned'}
    >
      <div className="equipment-name">
        <div
          data-testid={`equipment-assignment-${equipment.key}-icon`}
          className="equipmentIcon"
          onClick={() => updatePrimaryEquipment(assignment)}
        />
        <p>{`${equipment.key} - ${equipment.equipmentType.description}`}</p>
      </div>
      {rightIcon}
    </div>
  );
}

EquipmentAssignmentItem.propTypes = {
  assignment: PropTypes.shape({
    id: PropTypes.number.isRequired,
    equipment: PropTypes.shape({
      key: PropTypes.string.isRequired,
      equipmentType: PropTypes.shape({
        description: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  updatePrimaryEquipment: PropTypes.func.isRequired,
  canBeRemoved: PropTypes.bool.isRequired,
  routeId: PropTypes.number.isRequired
};

export default EquipmentAssignmentItem;
